import GroupSourceSelector from './src/main';

/* istanbul ignore next */
GroupSourceSelector.install = function(Vue) {
  Vue.component(GroupSourceSelector.name, GroupSourceSelector);
};

export default GroupSourceSelector;
